const Badges = {
  ActionNeeded: 'ActionNeeded',
  InterviewCanceled: 'InterviewCanceled',
  InterviewConfirmed: 'InterviewConfirmed',
  InterviewExpected: 'InterviewExpected',
  New: 'New',
  WaitingOnClient: 'WaitingOnClient',
} as const;

export type Badge = (typeof Badges)[keyof typeof Badges];

const EngagementStates = {
  Warmed: 'Warmed',
  WarmedYes: 'WarmedYes',
  Interested: 'Interested',
  Submitted: 'Submitted',
  InterviewingUnaccepted: 'InterviewingUnaccepted',
  InterviewingTalentDeclined: 'InterviewingTalentDeclined',
  InterviewingClientUnacceptedTalentAccepted:
    'InterviewingClientUnacceptedTalentAccepted',
  InterviewingExpectedExternal: 'InterviewingExpectedExternal',
  InterviewingExpectedManual: 'InterviewingExpectedManual',
  InterviewingConfirmed: 'InterviewingConfirmed',
  Interviewed: 'Interviewed',
  InterviewingCancelled: 'InterviewingCancelled',
  Selected: 'Selected',

  New: 'New',
} as const;

export const CandidateEngagementsConst = {
  Badges,
  EngagementStates,
} as const;
